
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VoicePage from "../pages/voice/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/voice",
    element: <VoicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
